; (function () {
	"use strict";
	function BjuiRelatedResourcesSlider() {
		var fn = {
			init: function () {
				fn.initSliders();
			},

			initSliders: function () {
				jQuery('.related-resources .splide').each(function (index, element) {
					fn.initSlider(element);
				})
			},

			initSlider: function (element) {
				let splide = new Splide(element, {
					perPage: 1.5,
					perMove: 1,
					fixedWidth: '240px',
					gap: '1rem',
					type: 'loop',
					pagination: false,
					arrows: false,
					mediaQuery: 'min',
					breakpoints: {
						500: {
							perPage: 2,
							perMove: 1,
						},
						800: {
							perPage: 2,
							perMove: 1,
							fixedWidth: '288px',
						},
						1000: {
							destroy: true,
						}
					}
				}).mount();


				let prevButton = element.querySelector('.related-resources__nav-button--prev');
				let nextButton = element.querySelector('.related-resources__nav-button--next');

				// Add event listeners
				prevButton.addEventListener('click', function () {
					console.log('clicky click prev')
					splide.go('<'); // Move to the previous slide
				});
				nextButton.addEventListener('click', function () {
					console.log('clicky click next')
					splide.go('>'); // Move to the next slide
				});

				// splide.destroy();
			},
		}
		jQuery(document).ready(fn.init);
	}
	new BjuiRelatedResourcesSlider();
})();